
import { Vue, Component } from 'vue-property-decorator';
import SwitchMock from '@/ui/components/devices/previews/components/SwitchMock.vue';
import MultimediaButtonMock from '@/ui/components/devices/previews/components/MultimediaButtonMock.vue';
import DeviceLayout from '@/ui/components/devices/components/DeviceLayout.vue';

@Component({
  components: {
    SwitchMock,
    MultimediaButtonMock,
    DeviceLayout,
  },
})
export default class TVPreview extends Vue {
  get previewNameLang() {
    return this.$t('devices.TV.previewName');
  }
}
